import { push } from 'connected-react-router';

import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const ACCOUNT_WITHHOLDING_OPEN_MODAL = 'ACCOUNT_WITHHOLDING_OPEN_MODAL';
export const ACCOUNT_WITHHOLDING_CLOSE_MODAL = 'ACCOUNT_WITHHOLDING_CLOSE_MODAL';
export const ACCOUNT_WITHHOLDING_REQUEST = 'ACCOUNT_WITHHOLDING_REQUEST';
export const ACCOUNT_WITHHOLDING_SUCCESS = 'ACCOUNT_WITHHOLDING_SUCCESS';
export const ACCOUNT_WITHHOLDING_FAILURE = 'ACCOUNT_WITHHOLDING_FAILURE';
export const IMYTREE_WITHHOLDING_FLAG = 'IMYTREE_WITHHOLDING_FLAG';

function openAccountWithholdingModal() {
  return {
    type: ACCOUNT_WITHHOLDING_OPEN_MODAL
  };
}

function closeAccountWithholdingModalModal() {
  return {
    type: ACCOUNT_WITHHOLDING_CLOSE_MODAL
  };
}

function requestAccountWithholding() {
  return {
    type: ACCOUNT_WITHHOLDING_REQUEST
  };
}

function setImyTreeWithholdingFlag(flag) {
  return {
    type: IMYTREE_WITHHOLDING_FLAG,
    showRate: flag
  };
}

function receiveAccountWithholding(accountWithholding) {
  return {
    type: ACCOUNT_WITHHOLDING_SUCCESS,
    accountWithholding
  };
}

function rejectAccountWithholding() {
  return {
    type: ACCOUNT_WITHHOLDING_FAILURE
  };
}

export function getImyTreeWithholdingRates() {
  return (dispatch) => {
    dispatch(setImyTreeWithholdingFlag(true));
  };
}

export function resetImyTreeWithholdingRatesFlag() {
  return (dispatch) => {
    dispatch(setImyTreeWithholdingFlag(false));
  };
}

export function getAccountWithholdingRates(customerId, accountId) {
  return (dispatch) => {
    dispatch(requestAccountWithholding());

    const promise = () => ApiService
      .getAccountWithholdingRates(customerId, accountId)
      .then(response => dispatch(receiveAccountWithholding(response.data)))
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectAccountWithholding, true));
        }
      });
    return promise();
  };
}

export function showImyTreeWithholding(formId) {
  return (dispatch) => {
    dispatch(getImyTreeWithholdingRates());
    return dispatch(push(`/w8imystructure/${ formId }`));
  };
}

export function hideImyTreeWithholding() {
  return (dispatch) => {
    dispatch(resetImyTreeWithholdingRatesFlag());
  };
}

export function showAccountWithholdingModal(form) {
  return (dispatch) => {
    dispatch(getAccountWithholdingRates(form.customerDbId, form.accountId));
    return dispatch(openAccountWithholdingModal(form));
  };
}

export function hideAccountWithholdingModal() {
  return (dispatch) => {
    dispatch(closeAccountWithholdingModalModal());
  };
}
